<template>
  <!-- 用户自助登记管理表 -->
  <div>
    <div style="margin-top: 15px;">
      <el-input placeholder="请输入搜索内容" clearable v-model="searchValue" class="input-with-select">
        <el-select v-model="select" slot="prepend" placeholder="请选择" clearable>
          <el-option label="亚马逊订单号" value="amazonOrderId"></el-option>
          <el-option label="客户邮箱" value="clientMail"></el-option>
        </el-select>
      </el-input>
      <el-select v-model="searchBar.status" clearable placeholder="请选择状态" filterable
                 @change="getSearchDates(true)">
        <el-option label="跟进中" value="1"></el-option>
        <el-option label="已解决" value="2"></el-option>
      </el-select>
      <el-select v-model="searchBar.demand" placeholder="请选择类型" @change="getSearchDates(true)">
        <el-option label="Refund" value="1"></el-option>
        <el-option label="Replacement" value="2"></el-option>
        <el-option label="Others" value="3"></el-option>
      </el-select>
      <el-button slot="append" icon="el-icon-search" @click="getSearchDates(true)"></el-button>
    </div>
    <div class="AutoLogin">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column label="亚马逊订单号" width="auto">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.amazonOrderId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户邮箱" width="170px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.clientMail }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户姓名" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.clientName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="电话" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="具体问题" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.detailedProblem }}</span>
          </template>
        </el-table-column>
        <el-table-column label="ASIN" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.asin }}</span>
          </template>
        </el-table-column>
        <el-table-column label="需求类型" width="auto" :formatter="statusFormatter">
        </el-table-column>
        <el-table-column label="other明细" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.detailedDemand }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="170px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.creationTime|datefilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="跟踪进度" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.processingProgress }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" style="margin-left: 10px">跟进中</span>
            <span v-else style="margin-left: 10px">已解决</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="250px">
          <template slot="header">
            <el-button type="primary" size="mini" @click="AddDialogVisible = true">新增</el-button>
            <!-- 导入 -->
            <el-upload
                class="upload-demo"
                action="string"
                :limit="1"
                :before-upload="handleBeforeUpload"
                :http-request="husinessLicenseHandler"
                :show-file-list="false"
                ref="upload"
                :file-list="fileList">
              <el-button size="mini" type="success" :loading="uploadLoading">导入</el-button>
            </el-upload>

            <el-button type="warning" size="mini" @click="exportExcel()" :loading="downloadLoading">导出</el-button>
          </template>

          <template slot-scope="scope">
            <el-button size="mini" @click="EditList(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row.amazonOrderId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加分页器 -->
      <div class="block">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="size"
            :page-sizes="[5, 10, 20,30,50,60,70,100]"
            layout="sizes,prev, pager, next,jumper"
            :total="total">
        </el-pagination>
      </div>
      <!-- 新增的对话框 -->
      <el-dialog title="客户自助登记管理表" :visible.sync="AddDialogVisible" width="30%" center>
        <el-form :label-position="labelPosition" label-width="80px" :model="addForm">
          <el-form-item label="亚马逊订单号">
            <el-input v-model="addForm.amazonOrderId"></el-input>
          </el-form-item>
          <el-form-item label="客户邮箱">
            <el-input v-model="addForm.clientMail"></el-input>
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input v-model="addForm.clientName"></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="addForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="ASIN">
            <el-input v-model="addForm.asin"></el-input>
          </el-form-item>
          <el-form-item label="具体问题">
            <el-input v-model="addForm.detailedProblem"></el-input>
          </el-form-item>
          <el-form-item label="需求类型">
            <el-select v-model="addForm.demand" placeholder="请选择">
              <el-option label="Refund" value="1"></el-option>
              <el-option label="Replacement" value="2"></el-option>
              <el-option label="Others" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="other明细">
            <el-input v-model="addForm.detailedDemand"></el-input>
          </el-form-item>

          <el-form-item label="跟踪进度">
            <el-input v-model="addForm.processingProgress"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="addForm.status" placeholder="请选择">
              <el-option label="跟进中" value="1"></el-option>
              <el-option label="已解决" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="AddDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitAdd()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑的对话框 -->
      <el-dialog title="客户自助登记管理表" :visible.sync="editDialogVisible" width="30%" center>
        <el-form :label-position="labelPosition" label-width="80px" :model="editForm">
          <el-form-item label="id" style="display:none">
            <el-input v-model="editForm.amazonOrderId"></el-input>
          </el-form-item>
          <el-form-item label="客户邮箱">
            <el-input v-model="editForm.clientMail"></el-input>
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input v-model="editForm.clientName"></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="editForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="具体问题">
            <el-input v-model="editForm.detailedProblem"></el-input>
          </el-form-item>
          <el-form-item label="ASIN">
            <el-input v-model="editForm.asin"></el-input>
          </el-form-item>
          <el-form-item label="需求类型">
            <el-select v-model="editForm.demand" placeholder="请选择">
              <el-option label="Refund" value="1"></el-option>
              <el-option label="Replacement" value="2"></el-option>
              <el-option label="Others" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="other明细">
            <el-input v-model="editForm.detailedDemand"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="editForm.status" placeholder="请选择">
              <el-option label="跟进中" value="1"></el-option>
              <el-option label="已解决" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitEdit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  apiDeleteAutoLoginList,
  apiAddAutoLoginList,
  apiEditAutoLoginList,
  apiAutoLoginSearch,
  buyOrderExport,
  apiImportFile
} from "../../api/AutoLogin";

export default {
  data() {
    return {
      AddDialogVisible: false,
      editDialogVisible: false,
      uploadLoading: false,
      downloadLoading: false,
      labelPosition: "right",
      //输入框
      searchBar: {
        status: '',
        demand: ''
      },
      searchValue: '',
      select: '',
      //新增表单数据：
      addForm: {},
      //编辑表单数据：
      editForm: {},
      //分页器数据
      currentPage: 1, //默认第一页 当前页
      size: 10,
      total: 0,//总条数
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      tableData: [],
      fileList: [],
      amazonOrderId: "",
    };
  },

  methods: {
    handleSizeChange(size) {
      this.size = size;
      this.getSearchDates(false);
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getSearchDates(false);
    },


    //删除数据
    handleDelete(id) {
      this.$confirm('是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apiDeleteAutoLoginList(id).then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.message);
            this.getSearchDates(false);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },


    statusFormatter(row) {
      // console.log(row);//行的数据demand
      // console.log(column);//列的数据
      let demandName = ''//定义一个变量存储过滤完成的状态
      switch (row.demand) {
        case '1':
          demandName = 'Refund'
          break
        case '2':
          demandName = 'Replacement'
          break
        case '3':
          demandName = 'Others'
          break
        default:
          break
      }
      return demandName
    },
    //点击确定按钮新增数据
    submitAdd() {
      apiAddAutoLoginList(this.addForm).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(res.data.message);
          this.AddDialogVisible = false;
          this.addForm = {};
          this.getSearchDates(false);
        } else {
          this.$message.warning(res.data.message);
          return false;
        }
      });
    },
    //修改表单数据 双向修改改成深拷贝
    EditList(data) {
      this.editDialogVisible = true;
      this.editForm = JSON.parse(JSON.stringify(data));
    },
    //点击编辑按钮修改数据
    submitEdit() {
      apiEditAutoLoginList({
        id: this.editForm.amazonOrderId,
        data: this.editForm,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(res.data.message);
          this.getSearchDates(false)
          this.editDialogVisible = false;
          this.editForm = {};
        } else {
          this.$message.warning(res.data.message);
          return false;
        }
      });
    },
    //导入
    handleBeforeUpload(file) {//上传文件之前的钩子，参数为上传的文件
      if (file.name.indexOf("xls") === -1 && file.name.indexOf("xlsx") === -1) {
        this.$message.warning("上传模板只能是 xls、xlsx格式!");
        return false;
      }
    },
    // 成功
    husinessLicenseHandler(params) {//覆盖
      this.uploadLoading = true;
      const _file = params.file;
      var formData = new FormData()// 通过 FormData 对象上传文件
      formData.append('file', _file)
      apiImportFile(formData).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: 'success'
          });
          this.getSearchDates(true);
        } else {
          this.$message.error('导入失败');
        }
      }).finally(() => {
        this.fileList = [];
        this.uploadLoading = false;
      })
    },

    // 导出
    exportExcel() {
      this.downloadLoading = true;
      var filename = '售后登记表-卖家.xlsx'
      buyOrderExport({q:JSON.stringify(this.searchBar)}).then((res) => {
        const link = document.createElement('a')
        let blob = new Blob([res.data], {type: "application/vnd.ms-excel"})
        let objectUrl = URL.createObjectURL(blob) // 创建URL
        link.href = objectUrl
        link.download = filename
        link.click()
        link.remove()
        URL.revokeObjectURL(objectUrl);
      }).finally(() => {
        this.downloadLoading = false;
      })
    },

    getSearchDates(boolean) {
      delete this.searchBar.amazonOrderId;
      delete this.searchBar.clientMail;
      if (!this.common.isBlank(this.select)) {
        this.$set(this.searchBar, this.select, this.searchValue);
      }
      this.searchBar = this.common.clearNull(this.searchBar);

      apiAutoLoginSearch({
        page: this.currentPage = 1,
        size: this.size,
        q: JSON.stringify(this.searchBar),
        sort: "creationTime",
        direction: "DESC"
      }).then((res) => {
        if (res.data.code === 200) {
          if (boolean) {
            this.$message.success(res.data.message)
          }
          this.tableData = res.data.data.content;
          this.total = res.data.data.totalElements;
        }
      });
    }
  },

  created() {
    //点进来就开始获取列表数据
    this.getSearchDates();
  },
  //日期的格式化
  filters: {
    datefilter: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
      //这里的日期格式可自定义
    },
  },
};
</script>

<style lang='less' scoped>
.el-input-group {
  margin-left: 30px;
  width: 500px;
}

.AutoLogin {
  padding: 50px 30px;

  .el-pagination {
    padding: 32px 0px;
  }
}
</style>